

import { useTableColumnsFactibilidadCorporativa, useTableFilter, useTableServerSideFiltering } from '@/shared/hooks';
import GeneralTable from '@/shared/components/ui/GeneralTable';
import { Grid, IconButton, Tooltip, } from '@mui/material';
import {
  EstadoFactibilidadCorporativaENUM,
  ROUTER_PATHS, TABLE_CONSTANTS,
} from '@/shared';
import { useNavigate } from 'react-router-dom';
import { Visibility } from '@mui/icons-material';
import { useFetchGetfactibilidadCorporativos } from '@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions';

import InfoCoordendas from '@/shared/components/ui/InfoCoordendas/InfoCoordendas';
import { IFactibilidadCorporativo } from '@/shared/interfaces/erp/factibilidad_corporativo';
import { useState } from 'react';


interface TableInspeccionFactibilidadCorporativoProps {
  showCustomActionBtnSpace?: boolean
  enableEditing?: boolean
  showInspected?: boolean
  estado_factibilidad?: EstadoFactibilidadCorporativaENUM
  aceptado_factibilidad?: boolean
}

export default function TableInspeccionFactibilidadCorporativo({
  showCustomActionBtnSpace = true,
  enableEditing = true,
  showInspected = false,
  estado_factibilidad,
  aceptado_factibilidad,
}: TableInspeccionFactibilidadCorporativoProps) {
  // useCheckPermissionsArray([
  //   PermissionsEnum.api_view_preventa,
  //   PermissionsEnum.api_change_preventa
  // ]);

  const navigate = useNavigate();
  const [rowSelection, setRowSelection]=useState({})

  ///* Hook
  const {
    columnsFactibilidad
  } = useTableColumnsFactibilidadCorporativa();

  ///* Fetch


  ///* Hook

  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const {
    isLoading,
    data: dataFactibilidadCorporativa,
    isRefetching
  } = useFetchGetfactibilidadCorporativos(
    {
      page: pageIndex + 1,
      page_size: pageSize,
      ...filterObject,
      filterByState: false,
      estado_factibilidad: estado_factibilidad,
      aceptado_factibilidad: aceptado_factibilidad,
      fecha_inspeccion_isnull: showInspected?false:true
    }
  );


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IFactibilidadCorporativo>
            columns={columnsFactibilidad}
            data={dataFactibilidadCorporativa?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={dataFactibilidadCorporativa?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            //
            enableSelectAll
            enableRowSelection
            rowSelection={rowSelection}
            setRowSelection={setRowSelection}
            pinLeftColumnIndexes={[0,1,2]}
            // crud
            canDelete={false}
            canEdit={false}
            positionActionsColumn='first'
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
            enableEditing={enableEditing}
            showCustomActionBtnSpace={showCustomActionBtnSpace}

            customActionBtnSpace={(value) => {
              return (
                <>
                  <Grid container>
                    <Grid item >
                      <Tooltip placement='top' title='Ver Factibilidad Corporativa'>
                        <IconButton
                          onClick={() => {
                            //navigate(`${ROUTER_PATHS.ventas.preventaCorporativoViewNav}/${value.id_preventa_coorporativa}/${value.prospecto_data.id_prospecto}`);
                            navigate(`${ROUTER_PATHS.noc.inspeccionCorporativoNav}/${value.id_factibilidad_coorporativa}`);

                          }}
                        >
                          <Visibility />
                        </IconButton>
                      </Tooltip>
                    </Grid>

                  </Grid>
                </>
              )
            }
            }

          />
        </Grid>
        <InfoCoordendas/>
      </Grid>

    </>
  );


}

